export default "Coups de pouce industriels 2026 — Bonifications CEE | Solution Éco France";
